// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2pDPj","buttons":"RemoveExpirationActionButtons_buttons__7fbYZ"};